import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { RotateCw } from 'lucide-react';
import { api } from '@/lib/api';
import { cn } from '@/lib/utils';
import { Tooltip } from './Tooltip';

/**
 * Bot-restart icon for the app rail. Admin-only — hidden via the `visible`
 * prop rather than checking auth here. Two clicks: the first arms it (turns
 * red for 4s), the second queues the restart.
 */
export function RestartButton({ visible }: { visible: boolean }) {
  const [confirmed, setConfirmed] = useState(false);

  const mut = useMutation({
    mutationFn: () => api<{ queued: boolean }>('/api/system/restart', { method: 'POST' }),
    onSuccess: () => {
      setConfirmed(false);
      alert('Restart wurde in die Queue gelegt. Der Bot startet in wenigen Sekunden neu.');
    },
  });

  if (!visible) return null;

  return (
    <Tooltip label={confirmed ? 'Sicher? Nochmal klicken.' : 'Bot neu starten'}>
      <button
        type="button"
        aria-label="Bot neu starten"
        disabled={mut.isPending}
        onClick={() => {
          if (!confirmed) {
            setConfirmed(true);
            setTimeout(() => setConfirmed(false), 4000);
            return;
          }
          mut.mutate();
        }}
        className={cn(
          'flex h-10 w-10 items-center justify-center rounded-full transition-colors',
          confirmed
            ? 'bg-destructive text-destructive-foreground'
            : 'text-muted-foreground hover:bg-accent hover:text-foreground'
        )}
      >
        <RotateCw className={cn('h-5 w-5', mut.isPending && 'animate-spin')} />
      </button>
    </Tooltip>
  );
}
